import React from 'react';
import { Award, Target, Users, TrendingUp } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="about-section" id="about">
      <div className="section-container">
        <div className="about-grid">
          {/* Left Column - Image */}
          <div className="about-image-wrapper">
            <div className="about-image-container">
              <img 
                src="https://images.pexels.com/photos/7876314/pexels-photo-7876314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
                alt="Professional trademark attorneys"
                className="about-image"
              />
              <div className="about-badge">
                <div className="about-badge-content">
                  <div className="about-badge-number">15+</div>
                  <div className="about-badge-text">Years of Excellence</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="about-content">
            <div className="section-header-inline">
              <span className="section-label">About Trademark Texticon</span>
              <h2 className="section-title">
                Your Trusted Partner in
                <span className="title-highlight"> Trademark Protection</span>
              </h2>
            </div>

            <p className="about-text">
              Since 2010, Trademark Texticon has been the premier choice for businesses seeking 
              comprehensive trademark registration services. Our team of experienced trademark 
              attorneys and legal professionals specializes exclusively in intellectual property 
              protection, ensuring your brand receives the expert attention it deserves.
            </p>

            <p className="about-text">
              With over 1,000 successfully registered trademarks and a 98% USPTO approval rate, 
              we've built our reputation on precision, reliability, and unwavering commitment to 
              protecting our clients' brand identities. From startups to established enterprises, 
              we provide tailored trademark solutions that secure your competitive advantage.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
